import { useEffect, useState } from 'react';

function setStack(stack: number) {
    document.documentElement.setAttribute('scroll-lock', `${stack}`);
}

setStack(0);

export const useScrollLock = (isLocked: boolean) => {
    const [isInitialized, setInitialized] = useState(false);
    useEffect(() => {
        if (!isInitialized) {
            return;
        }
        const html = document.documentElement;
        const body = document.body;
        const header = document.querySelector('.layout-header') as HTMLElement;
        const stack = +(html.getAttribute('scroll-lock') || 0);

        if(isLocked && stack > 0) {
            setStack(stack + 1);
            return;
        }

        if(!isLocked && stack > 1) {
            setStack(stack - 1);
            return;
        }

        if (isLocked) {
            setStack(stack + 1);

            const paddingRight = window.innerWidth - document.documentElement.clientWidth;

            header.style.paddingRight = `${paddingRight}px`;
            body.style.paddingRight = `${paddingRight}px`;
            html.style.overflow = 'hidden';
            body.style.overflow = 'hidden';
        } else {
            if(stack > 0){
                setStack(stack - 1);
            }

            header.style.paddingRight = '';
            body.style.paddingRight = '';
            html.style.overflow = '';
            body.style.overflow = '';
        }

        return () => {
            html.style.overflow = '';
            body.style.overflow = '';
        };
    }, [isLocked]); // eslint-disable-line

    useEffect(() => {
        setInitialized(true);
    }, []);
};
